import {
  GET_SUCCESS_CONFIGURATION_REQUEST,
  GET_SUCCESS_CONFIGURATION_SUCCESS,
  GET_SUCCESS_CONFIGURATION__FAILED,
} from './actionTypes';

const initialState = {
  data: null,
};

const list = (state = initialState, {
  type, data,
}) => {
  switch (type) {
    case GET_SUCCESS_CONFIGURATION_REQUEST:
      return {
        ...state, loading: true,
      };
    case GET_SUCCESS_CONFIGURATION_SUCCESS:
      return {
        ...state, loading: false, data,
      };
    case GET_SUCCESS_CONFIGURATION__FAILED:
      return {
        ...state, loading: false,
      };
    default:
      return state;
  }
};

export default list;
